import React from 'react';
import PropTypes from 'prop-types';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useTranslation } from 'react-i18next';
import ActionChip from '../../../Widgets/ActionChip/ActionChip';
import Styles from './ClientDataTable.module.scss';

const ClientDataActions = ({
  client, handleEdit, direction = 'rtl',
}) => {
  const { t } = useTranslation();

  return (
    <div className={Styles.rowActions}>
      <ActionChip
        label={t('EditClient')}
        icon={<EditOutlinedIcon sx={{ fontSize: 'var(--xtram-panel-icon-sm, 16px)' }} />}
        onClick={() => handleEdit(client)}
        direction={direction}
        maxLabelWidth={140}
        className={Styles.editBtn}
        borderColor="#CAD7EE"
      />
    </div>
  );
};

ClientDataActions.propTypes = {
  client: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  direction: PropTypes.string,
};

export default ClientDataActions;
